<template>
    <div v-if="label"
         class="data-item">
        <label class="data-item__label">{{ label }}</label>
        <span class="data-item__value">{{ value }}</span>
    </div>
</template>

<script>

export default {

    props: {
        label: {
            type: String,
            default: null,
        },
        value: {
            type: [ String, Number ],
            default: '-',
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\app-core\_data-item.scss

.data-item {
    font-weight: bold;
    display: flex;
    justify-content: space-between;

    @include element('label') {
        display: none;

        @include bp-min-small {
            text-align: left;
            display: block;

            &:after {
                content: ': '
            }
        }
    }

    @include element('value') {
        display: block;
        text-align: right;
        width: 100%;

        @include bp-min-small {
            width: auto;
        }
    }
}

</style>
